module.exports = __webpack_public_path__ + "static/media/cert_49.23a7f560.jpg";